/**
 * ReviewReply — the shop's reply to a customer review, rendered as a comment
 * thread (avatar = shop logo or initial, name = shop name, body = reply).
 * Shared by the inline ReviewsSection and the full ReviewsModal.
 */
import React from 'react';
import styles from './reviewReply.module.css';

export default function ReviewReply({ reply, shopName, shopLogo, t }) {
  if (!reply?.body) return null;
  const name = shopName || t?.('reviews.shopReply', { defaultValue: 'Shop' }) || 'Shop';
  return (
    <div className={styles.reply} data-testid="review-reply">
      {shopLogo ? (
        <img src={shopLogo} alt="" className={styles.avatar} loading="lazy" />
      ) : (
        <div className={styles.avatarFallback} aria-hidden>{String(name).charAt(0).toUpperCase()}</div>
      )}
      <div className={styles.bubble}>
        <span className={styles.author}>{name}</span>
        <p className={styles.body}>{reply.body}</p>
      </div>
    </div>
  );
}
